import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useSignInContext } from './SignInContext';
import { FormikProvider, useFormik } from 'formik';
import { InputCode } from '../../components/form';
import { Button } from '../../components/UI';
import { useAuth } from '../../context/Auth';
import { Modal } from '../../components/Modal';
import { logger } from '../../helpers/logger';

const SignIn2FA = () => {
  const { t } = useTranslation();
  const { state, dispatch } = useSignInContext();
  const { confirmSignIn } = useAuth();

  const [error, setError] = useState('');

  const formik = useFormik({
    initialValues: {
      code: '',
    },
    onSubmit: (values) => {
      setError('');
      confirmSignIn(state.cognitoUser, values.code)
        .then((res) => {
          logger.log('confirmSignIn', res);
          formik.setSubmitting(false);
        })
        .catch((err) => {
          setError(err.message);
        })
        .finally(() => formik.setSubmitting(false));
    },
    validateOnMount: true,
  });

  return (
    <Modal
      isOpen={true}
      backdrop={'solid'}
      handleMerlinLogo={true}
      isClosable={false}
      padding={'huge'}
    >
      <div className={'text-center'}>
        <h1 className={'text-black text-xl font-semibold mb-4 dark:text-white'}>
          {t('verifyTotp.title')}
        </h1>
        <p className={'text-grey-50 text-sm whitespace-pre-wrap'}>
          {t('verifyTotp.subtitle')}
        </p>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <div className="mt-12">
              <InputCode
                name="code"
                id="code"
                numberOfDigits={6}
                formik={formik}
                label={t('verifyTotp.form.label.code')}
                errorMessage={error}
              />
            </div>
            <div className="mt-10">
              <Button
                type="submit"
                variant="primary"
                buttonClass="w-64"
                loading={formik.isSubmitting}
              >
                {t('verifyTotp.form.continue')}
              </Button>
            </div>
          </form>
        </FormikProvider>
        <div className="mt-5">
          <span className="text-grey-80 text-sm dark:text-grey-50">
            {t('verifyTotp.form.problem')}
          </span>
          <button
            className="text-sm text-black font-semibold dark:text-white"
            onClick={() => {
              dispatch({
                type: 'SET_STEP',
                payload: 'REQUEST_2FA_BYPASS',
              });
            }}
          >
            {t('verifyTotp.form.clickHere')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SignIn2FA;
